import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Autocomplete, AutocompleteProps } from "@react-google-maps/api";

import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
// ==============================================================
type Props = {
  hidden?: boolean;
  onPlaceChanged: (selectedStr?: string) => void;
  onLoad: (autoCompleteRef: google.maps.places.Autocomplete) => void;
  autoCompleteBounds?:
    | google.maps.LatLngBounds
    | google.maps.LatLngBoundsLiteral;
  autoCompleteErr?: string;

  // Looks like not needed in our case.
  inputValue?: string;
  setInputValue: (v: string) => void;
  onInputRefChange?: (ref?: React.MutableRefObject<TextFieldProps>) => void;

  //I create purpose create_address variable here so we can use the input value of google map for creating user address
  isCreateAddress?: boolean;
};
// ==============================================================

const CheckOutMapAutoComplete = ({
  inputValue,
  setInputValue,
  onInputRefChange,
  hidden = false,
  onLoad,
  onPlaceChanged,
  autoCompleteBounds = undefined,
  autoCompleteErr,
  isCreateAddress,
}: Props) => {
  const textFieldRef = useRef<TextFieldProps>(null);
  const [_searchBoxInternalRef, setSearchBoxInternalRef] = useState<
    google.maps.places.Autocomplete | undefined
  >();

  const onPlaceChangedInternal = () => {
    onPlaceChanged();
  };

  const onLoadInternal = (newSearchBoxRef: google.maps.places.Autocomplete) => {
    onLoad(newSearchBoxRef);
    setSearchBoxInternalRef(newSearchBoxRef);
  };

  useEffect(() => {
    if (onInputRefChange) {
      onInputRefChange(textFieldRef);
    }
  }, [onInputRefChange, textFieldRef]);

  return (
    <Box hidden={hidden}>
      <Autocomplete
        onLoad={onLoadInternal}
        restrictions={{ country: "PH" }}
        bounds={autoCompleteBounds}
        // options={{ strictBounds: true }}
        fields={["geometry", "formatted_address", "place_id"]}
        onPlaceChanged={onPlaceChangedInternal}
      >
        <TextField
          inputRef={textFieldRef}
          id="google_checkout_autocomplete"
          variant="outlined"
          fullWidth
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          sx={{ mt: 2, mb: 1 }}
          label="Additional Address Information / Block / Floor / Room / Landmark"
          placeholder="eg. blk 3 lot 12 phase 4A Bautista St."
          name="delivery_address"
          // DO NOT USE THIS `value`. ON CHECKOUT BECAUSE THIS MESSES UP THE GOOGLE VALUE
          //Use only through create address component
          value={isCreateAddress ? inputValue : null}
          onChange={(e) => {
            setInputValue(e.target.value);
          }}
          error={!!autoCompleteErr}
          helperText={autoCompleteErr}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  color="error"
                  onClick={() => {
                    textFieldRef.current.value = "";
                    setInputValue("");
                  }}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Autocomplete>
    </Box>
  );
};

export default CheckOutMapAutoComplete;
